<i18n>
{
  "kr": {
"Rodmap": "로드맵",
    "__END__":""
  }

}
</i18n>

<template>
  <div>
    <h1>{{$t("Roadmap")}}</h1>
    <div>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <span>** Updated on June 10, 2019</span>
    </div>
    <br>
    <b-container mg="*" class="left">
      <b-row class="margin-item">
        <b-col>
          <b>Dark theme</b>
          - Beta(released)
          <br>Supports dark themes with comfortable eyes.
          <br>Check "the use dark theme button" in Setting menu.
        </b-col>
      </b-row>
      <b-row class="margin-item">
        <b-col>
          <b>Total search</b>
          - Alpha(released)
          <br>Supports integrated search of all Memos and Notes together. Search conveniently. :)
          <br>Supports preview of your search as well.
          <br>Press F3 to search in the current memo.
          <b>Double-click F3 to search in all notes</b>
        </b-col>
      </b-row>
      <b-row class="margin-item">
        <b-col>
          <b>Application shortcut key</b>
          - Beta(released)
          <br>Open the Synapbook window with alt+z key.
        </b-col>
      </b-row>
      <b-row class="margin-item">
        <b-col>
          <b>Note - supports repositioning of notes</b>
          - (released)
          <br>Supports ordering in the note list.
        </b-col>
      </b-row>
      <b-row class="margin-item">
        <b-col>
          <b>Encryption box</b>
          - Under development(target date is within June)
          <br>You can encrypt the contents with the encryption key. Use the encryption box for notes that need security.
        </b-col>
      </b-row>
      <b-row class="margin-item">
        <b-col>
          <b>Save/Load notes from files</b>
          - Under development(target date is within May)
          <br>Save and open a tree note as a file. Now use your synapbook as a file editor.
        </b-col>
      </b-row>
      <b-row class="margin-item">
        <b-col>
          <b>Android: total search</b>
          <br>Android app also supports integrated search.
        </b-col>
      </b-row>
      <b-row class="margin-item">
        <b-col>
          <b>Memo/Note - ling tag search</b>
          <br>You can view and search for a list of lines that you have placed tags on the line.
        </b-col>
      </b-row>
      <b-row class="margin-item">
        <b-col>
          <b>History - diff view</b>
          <br>Supports displaying only the changes made to past content views.
        </b-col>
      </b-row>
      <b-row class="margin-item">
        <b-col>
          <b>Note - support tag</b>
          <br>It also supports tagging notes.
        </b-col>
      </b-row>
    </b-container>Thanks.
  </div>
</template>

<script>
export default {
  name: "support-page"
};
</script>

<style lang="css" scoped>
.counter-number {
  font-size: 40px;
}

.left {
  text-align: left;
}
.margin-item {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/RoadmapPage.vue